import { UIHeading3, UIText1 } from '@cian/ui-kit';

import * as React from 'react';

import styles from './styles.css';

export interface IActionsMenuHeaderProps {
  name?: string;
  description?: string | null;
}

export const ActionsMenuHeader: React.FC<IActionsMenuHeaderProps> = ({ name, description }) => {
  return (
    <>
      <div className={styles['title']}>
        <UIHeading3>{name}</UIHeading3>
      </div>
      {description && (
        <div className={styles['description']}>
          <UIText1 color="text-secondary-default">{description}</UIText1>
        </div>
      )}
    </>
  );
};
